module.exports = __webpack_public_path__ + "assets/img/container-android2.5b47ba1.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/container-android2.png
// module id = DCAM
// module chunks = 50